import imageCompression from 'browser-image-compression';

export const compressImage = async (file: File): Promise<File> => {
  const options = {
    maxSizeMB: 0.8,          // Max size ~800KB
    maxWidthOrHeight: 1920,  // Max dimension 1920px (Full HD)
    useWebWorker: true,      // Runs in background (doesn't freeze screen)
  };

  try {
    const compressedFile = await imageCompression(file, options);
    return compressedFile;
  } catch (error) {
    console.error("Image compression failed, using original:", error);
    return file; // Safety fallback: upload original if compression fails
  }
};